export default __webpack_public_path__ + "static/media/create_inspection_job.3bc5af0f.svg";